<shrd-uic-tab-slider [tabs]="allTabs | async" role="tablist">
  <ng-content></ng-content>
</shrd-uic-tab-slider>
